import { Component, OnDestroy } from '@angular/core';
import { NavController,ViewController,NavParams,ToastController,AlertController,ModalController,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-editProduct',
  templateUrl: 'editProduct.html'
})
export class EditProductPage implements OnDestroy {
  url: any;
  product: any;
  menu: any;
  alertTitle: any;
  contain: any;
  not_contain: any;
  could_contain: any;
  allergyText: any;
  width: any;
  height: any;
  variants = [];
  max: any;
  qty = 1;
  cont = 0;
  data: any;
  ingredients = [];
  private _onDestroy = new Subject();

  constructor(public navCtrl: NavController,
              public provider: provider,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public modalCtrl: ModalController,
              public platform: Platform,
              public customizer: CustomizerProvider) {


    let varIngrGruppo=[];
    let varIngr=[];
    this.url = provider.getUrl();

    this.data = provider.getMenu();
    this.product = navParams.get('item');
    this.max = this.product.max;
    this.cont = this.product.cont;

    //varianti/ingredienti del gruppo
    for(let i=0; i<this.data.menu.righe.length; i++) {
      if(this.data.menu.righe[i]._id == this.product.prodotto.parent) {
        for(let j=0; j<this.data.menu.righe[i].content.varIngr.length; j++) {
          varIngrGruppo.push(this.data.menu.righe[i].content.varIngr[j]);
        }
      }
    }

    //recupero degli oggetti dalla libreria
    for(let j=0; j<varIngrGruppo.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == varIngrGruppo[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }
    for(let j=0; j<this.product.prodotto.content.varIngr.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == this.product.prodotto.content.varIngr[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }
    
    //rimozione dei duplicati
    let obj = [];
    varIngr.forEach((value, key) => {
      let exists = false;
      obj.forEach((value2, key) => {
        if(value._id == value2._id) exists = true;
      })
      if(!exists) obj.push(value);
    })

    //inserimento della proprietà "quantità" per ogni variante/ingrediente e divisione in ingredienti/varianti
    for(let i=0; i<obj.length; i++) {
      obj[i].quantita = 0;
      if(!obj[i].extraProps.isIngrediente) {
        this.variants.push(JSON.parse(JSON.stringify(obj[i])));
      }
      else {
        this.ingredients.push(JSON.parse(JSON.stringify(obj[i])));
      }
    }

    for(let i=0; i<this.product.varIngr.length; i++) {
      for(let j=0; j<this.ingredients.length; j++) {
        if(this.ingredients[j]._id == this.product.varIngr[i]._id) {
          this.ingredients.splice(j,1);
          this.ingredients.splice(j,0,this.product.varIngr[i])
        }
      }
      for(let k=0; k<this.variants.length; k++) {
        if(this.variants[k]._id == this.product.varIngr[i]._id) {
          this.variants.splice(k,1);
          this.variants.splice(k,0,this.product.varIngr[i])
        }
      }
    }

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
    });

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getImg(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  getUrl(prod) {
    let imageType = this.data.settings.imageType;

    if(prod.extraProps.imageType) {
      imageType = prod.extraProps.imageType;
    }
    switch(imageType) {
      case 'S':
        return this.url + prod.img + '?h=' + (this.height/4);
      case 'M':
        return this.url + prod.img + '?h=' + (this.height/3);
      case 'L':
        return this.url + prod.img + '?h=' + (this.height/2);
    }
  }

  getImgAllergene(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  getAllergy(alg) {
    return this.url + '/' + alg + '?w=50'
  }

  // aggiungere o rimuovere quantità del prodotto
  addQty() {
    this.product.quantita++;
  }
  removeQty() {
    if(this.product.quantita > 1) {
      this.product.quantita--;
    }
  }

  //aggiungere o rimuovere quantità della variante
  increaseQty(item) {
    if(item.quantita < 0) {
      item.quantita++;
      this.cont--;
    }
    else {
      if(this.cont != this.max) {
        item.quantita++;
        this.cont++;
      }
      else {
        this.showAlert();
      }
    }
  }
  decreaseQty(item) {
    if(item.quantita <= 0) {
      if(this.cont != this.max) {
        item.quantita--;
        this.cont++;
      }
      else {
        this.showAlert();
      }
    }
    else {
      item.quantita--;
      this.cont--;
    }
  }

  //allergie
  showAllergy(allergy) {
    let text,contain,allergyText;

    this.translateService.get('CONTIENE').takeUntil(this._onDestroy).subscribe(value => { contain = value });
    this.translateService.get(allergy).takeUntil(this._onDestroy).subscribe(value => { allergyText = value });

    text = '<img src="assets/ALLERGENI/' + allergy + '.png"><br><h2>' + contain + '<br><b>' + allergyText + '</b></h2>';

    let alert = this.alertCtrl.create({
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  //varianti
  showAlert() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi aggiungere altre varianti!',
      buttons: ['OK']
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  //aggiungere al carrello il prodotto
  sendData(prod) {
    let varianti = [];
    let varPerc = [];
    let ingPerc = [];

    for(let i=0; i<this.ingredients.length; i++) {
      if(this.ingredients[i].quantita != 0) {
        if(this.ingredients[i].prezzo.tipo == 1) {
          varianti.push(this.ingredients[i]);
        }
        else if(this.ingredients[i].prezzo.tipo == 2) {
          ingPerc.push(this.ingredients[i]);
        }
      }
    }

    for(let i=0; i<this.variants.length; i++) {
      if(this.variants[i].quantita != 0) {
        if(this.variants[i].prezzo.tipo == 1) {
          varianti.push(this.variants[i]);
        }
        else if(this.variants[i].prezzo.tipo == 2) {
          varPerc.push(this.variants[i]);
        }
      }
    }

    for(let i=0;i<varPerc.length;i++) {
      varianti.push(varPerc[i]);
    }

    prod.varIngr = varianti;

    this.provider.editItemCart(prod);
    this.viewCtrl.dismiss();
  }

  readMore(descr) {
    let text;

    text = this.provider.renderDescrEstesa(descr);

    let alert = this.alertCtrl.create({
      title: 'Informazioni',
      message: text,
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/editProduct/editProduct.ts